import type Keycloak from 'keycloak-js'
import ApiError from './ApiError'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
abstract class Api {
  private static readonly API_URL =
    process.env.REACT_APP_API_URL != null
      ? `${process.env.REACT_APP_API_URL}/api`
      : '/api'

  protected static getPath(path: string): string {
    return `${Api.API_URL}/${path}`
  }

  private static getHeaders(keycloak?: Keycloak): HeadersInit {
    const headers: HeadersInit = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      tenant: 'f2821944-04c1-4750-bb4e-0d7cc80a5288',
    }

    if (keycloak !== undefined && keycloak.token != null) {
      headers.Authorization = `Bearer ${keycloak.token}`
    }

    return headers
  }

  private static handleResponseData(data: Response): any {
    if (!data.ok) {
      // TODO: Do something with this type of errors... (need a class for that)
      throw new ApiError(data.statusText, data.status)
    }

    return data.status !== 204 ? data.json() : null
  }

  private static async postPut(
    method: string,
    path: string,
    body: object,
    keycloak?: Keycloak,
  ): Promise<any> {
    const data = await fetch(this.getPath(path), {
      method,
      body: JSON.stringify(body),
      headers: this.getHeaders(keycloak),
    })

    return await Api.handleResponseData(data)
  }

  static async get(path: string, keycloak?: Keycloak): Promise<any> {
    const data = await fetch(this.getPath(path), {
      method: 'GET',
      headers: this.getHeaders(keycloak),
    })

    return await Api.handleResponseData(data)
  }

  static async delete(path: string, keycloak?: Keycloak): Promise<any> {
    const data = await fetch(this.getPath(path), {
      method: 'DELETE',
      headers: this.getHeaders(keycloak),
    })

    return await Api.handleResponseData(data)
  }

  static async post(
    path: string,
    body: object,
    keycloak?: Keycloak,
  ): Promise<any> {
    return await this.postPut('POST', path, body, keycloak)
  }

  static async put(
    path: string,
    body: object,
    keycloak?: Keycloak,
  ): Promise<any> {
    return await this.postPut('PUT', path, body, keycloak)
  }
}

export default Api
